import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import SubmissionDetails from '../../../SubmissionDetails';
import TextContent from '../../Details/_partials/TextContent';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import Stats from '../../../Stats';
import s from './Journal.scss';
var JournalContent = function (_a) {
    var _b, _c;
    var textContent = _a.deviation.textContent, deviation = _a.deviation, _d = _a.withArtist, withArtist = _d === void 0 ? true : _d;
    var isLegacy = (textContent === null || textContent === void 0 ? void 0 : textContent.html.type) === 'writer';
    var isLegacyView = isLegacy && !((_b = deviation.extended) === null || _b === void 0 ? void 0 : _b.journalSkinFullwidth);
    var isFullWidthView = isLegacy && ((_c = deviation.extended) === null || _c === void 0 ? void 0 : _c.journalSkinFullwidth);
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var isMobile = useContext(MobileContext);
    var stats_on_the_right = useFlag('stats_on_the_right') && !isMobile;
    var isBlockedBySubscription = useSubscriptionTier(deviation).isBlockedBySubscription;
    return (React.createElement(React.Fragment, null,
        withArtist && (React.createElement("div", { className: s['author-block'] },
            React.createElement(SubmissionDetails, { deviation: deviation }),
            !isMobile && ' ')),
        !stats_on_the_right && (React.createElement("div", { className: s['stats'] },
            React.createElement(Stats, { deviation: deviation }))),
        !isBlockedBySubscription && (React.createElement("div", { className: s['wrapper'] }, isExtendedLoaded && (React.createElement(TextContent, { className: classnames(s['text-content'], isLegacyView && s['is-legacy-journal'], isFullWidthView && s['is-fullwidth-skin']), textContent: textContent, deviationId: deviation.deviationId, disableStylesForLegacy: isFullWidthView }))))));
};
JournalContent.displayName = 'JournalContent';
export default JournalContent;
//# sourceMappingURL=Journal.js.map